import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Input, Modal, PageHeader, Spin } from "antd";
import { LanguageContext } from "../../context/LanguageContext";
import _ from "lodash";
import "../viewFormModel.css";
import { NCRServiceAction } from "../../_actions/ncr.service";
import moment from "moment";
export const ViewNcrDetails = ({ masterId, name }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { language, setLanguage, t } = useContext(LanguageContext);
  const getNCRByMaster = (id) => {
    let obj = {
      masterId: id,
    };
    setLoading(true);
    NCRServiceAction.getNCRByMaster(obj).then((res) => {
      res &&
        res.text().then((criminalList) => {
          let criminal = JSON.parse(criminalList);
          let list = criminal.data;
          console.log("list", list);
          setData(list);
        });

      setLoading(false);
    });
  };
  useEffect(() => {
    if (masterId) {
      getNCRByMaster(masterId);
    }
  }, [masterId]);
  return (
    <>
      <PageHeader
        title={
          <>
            अदखलपात्र गुन्हे: <strong>id: {masterId}</strong>
          </>
        }
      >
        <p>Name: {name} </p>
        <div className="ant-table-wrapper" style={{ overflowX: "auto" }}>
          <table
            className="ant-table ant-table-bordered"
            style={{ border: "1px solid rgb(26, 20, 20)", width: "100%" }}
          >
            <thead className="ant-table-thead">
              <tr>
                <th
                  className="ant-table-cell"
                  style={{ border: "1px solid rgb(26, 20, 20)" }}
                >
                  {t("sr.no")}
                </th>
                <th
                  className="ant-table-cell"
                  style={{ border: "1px solid rgb(26, 20, 20)" }}
                >
                  NCR number
                </th>
                <th
                  className="ant-table-cell"
                  style={{ border: "1px solid rgb(26, 20, 20)" }}
                >
                  नोंदवलेले डेट
                </th>
                <th
                  className="ant-table-cell"
                  style={{ border: "1px solid rgb(26, 20, 20)" }}
                >
                  शीर्षक
                </th>
                <th
                  className="ant-table-cell"
                  style={{ border: "1px solid rgb(26, 20, 20)" }}
                >
                  घटनेचा प्रकार
                </th>
                <th
                  className="ant-table-cell"
                  style={{ border: "1px solid rgb(26, 20, 20)" }}
                >
                  केलेली कारवाई
                </th>
                <th
                  className="ant-table-cell"
                  style={{ border: "1px solid rgb(26, 20, 20)" }}
                >
                  ऑफिसर चे नाव
                </th>
                <th
                  className="ant-table-cell"
                  style={{ border: "1px solid rgb(26, 20, 20)" }}
                >
                  {t("law") + " - " + t("section")}
                </th>
              </tr>
            </thead>
            <tbody className="ant-table-tbody">
              {data &&
                data.length > 0 &&
                data.map((ncr, index) => (
                  <>
                    <tr>
                      <td
                        className="ant-table-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {index + 1}
                      </td>
                      <td
                        className="ant-table-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {ncr.ncr_registernumber}
                      </td>
                      <td
                        className="ant-table-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {" "}
                        {moment(ncr.occurrence_datetime)
                          .local()
                          .format("YYYY-MM-DD hh:mm A")}
                      </td>

                      <td
                        className="ant-table-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {ncr.headingName}
                      </td>
                      <td
                        className="ant-table-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {ncr?.sub_heading_name &&
                          ncr?.sub_heading_name.length > 0 &&
                          ncr?.sub_heading_name.map((sub, index) => (
                            <>
                              {sub}
                              {","}
                            </>
                          ))}
                      </td>
                      <td
                        className="ant-table-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {ncr.actions_taken}
                      </td>
                      <td
                        className="ant-table-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {ncr.officer_name}
                      </td>
                      <td
                        className="ant-table-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {ncr.kalamKayda &&
                          ncr.kalamKayda.length > 0 &&
                          ncr.kalamKayda.map((kk, i) => {
                            return (
                              <div key={i}>
                                {kk.rulesName} - {kk.kalam}
                              </div>
                            );
                          })}
                      </td>
                    </tr>
                  </>
                ))}
            </tbody>
          </table>
        </div>
      </PageHeader>
    </>
  );
};
